import { useCallback, useState } from 'react';
import { useMediaQuery } from './useMediaQuery';

/**
 * Sección que en el celular arranca plegada (filtros, indicadores) para que la
 * planilla quede a la vista sin tener que scrollear. En escritorio siempre
 * está abierta.
 */
export const useMobileCollapse = (initiallyOpen = false) => {
  const isMobile = useMediaQuery();
  const [isOpen, setIsOpen] = useState(initiallyOpen);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);
  return { isMobile, isOpen: !isMobile || isOpen, toggle };
};
